import React from 'react';
import BasicAlert from './BasicAlert';
import { Loader } from 'hoi-poi-ui';
import './styles.scss';

const SpinnerAlert = ({ title, text, shrink = false }) => (
    <BasicAlert
        text={text}
        icon={<Loader color="white" size="small" />}
        type={'spinner'}
        title={title}
        shrink={shrink}
    />
);

export default SpinnerAlert;
